export default [
    { path: '/dashboard', component: require('./components/Dashboard.vue').default,
        meta: {
            title: 'Dashboard',
            page: 'dashboard',
        }
    },
    { path: '/profile', component: require('./components/Profile.vue').default },
    { path: '/developer', component: require('./components/Developer.vue').default },
    { path: '/users', component: require('./components/Users.vue').default },
    { path: '/roles', component: require('./components/Roles.vue').default },
    { path: '/products', component: require('./components/product/Products.vue').default },
    { path: '/product/tag', component: require('./components/product/Tag.vue').default },
    { path: '/product/category', component: require('./components/product/Category.vue').default },
    { path: '/sales/sales_mx', component: require('./components/sales/MSSaleDashboard.vue').default },

    /* simulation page*/
    { path: '/simulation', component: require('./components/Simulation.vue').default },

    { name: 'pending-cases', path: '/pending-cases', component: require('./components/PendingCases.vue').default },

    /* stats */
    { path: '/stats/sales_calls', component: require('./components/stats/SalesCalls.vue').default },
    { path: '/stats/sextortion_close_rate', component: require('./components/stats/SextortionCloseRate.vue').default },
    { path: '/stats/non_sextortion_close_rate', component: require('./components/stats/NonSextortionCloseRate.vue').default },
    { path: '/stats/p2_close_rate', component: require('./components/stats/P2CloseRate.vue').default },

    /* AuthorizeNet */
    { path: '/anet/recurring_billing', component: require('./components/anet/RecurringBilling.vue').default },
    { path: '/anet/transactions', component: require('./components/anet/Transactions.vue').default },
    { path: '/anet/held_transactions', component: require('./components/anet/HeldTransactions.vue').default },    

    /* ads data */
    { path: '/ads', component: require('./components/ads/AdsChart.vue').default },
    {
        path: '/collections', 
        component: require('./components/collections/Collection.vue').default,
        meta: {
            title: 'Collection',
            page: 'collections',
        }
     },

    /* admin route data */
    {   path: '/ACLPanel', component: require('./components/acl/ACLPanel.vue').default,
        meta: {
            title: 'ACLPanel',
            page: 'aclpanel',
        }
    },

    { path: '*', component: require('./components/NotFound.vue').default }
];
